<template>
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="card px-3 pt-5 pb-5" style="background-color: white; width: 30%;">
      <h2 class="text-center">Log in</h2>
      <div class="text-danger text-center my-2" v-if="errorMessage">{{ errorMessage }}</div>
      <div class="card-body">
        <form @submit.prevent="submit">
          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="text"
              class="form-control"
              v-model="form.email"
              id="email"
              aria-describedby="email"
            />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input
              type="password"
              class="form-control"
              v-model="form.password"
              id="exampleInputPassword1"
            />
          </div>
          <button type="submit" class="btn btn-primary btn-lg btn-block" :disabled="loading">
            Login
            <div class="spinner-border text-light position-absolute" role="status" v-if="loading">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      errorMessage: "",
      loading: false
    };
  },

  methods: {
    ...mapActions({
      login: "auth/login"
    }),

    submit() {
      this.loading = true;
      this.login(this.form)
        .then(() => {
          this.loading = false;

          this.$router.replace({
            name: "dashboard"
          });
        })
        .catch(error => {
          this.loading = false;

          this.errorMessage = error.response.data.message;
        });
    }
  }
};
</script>
